import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ThanhToan } from "./ThanhToan";
import { formatNumber } from "utils/currencyFormat";

export const BtnThanhToan = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Thanh toán"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
            <img  src="/app-assets/images/icon-thanh-toan-v2.png"/>
        </PopoversBootrap>
      </a>
      {show && (
        <ThanhToan
          show={show}
          onHide={handleClose}
          conNo={formatNumber(item.TienThanhLy + item.PhiKhac - item.TienDaTra)}
          ThanhLyId={item.ThanhLyID}
        />
      )}
    </>
  );
};
